<template>
    <div class="commodityDistribution">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'commodityDistribution'
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .commodityDistribution{
        height: 100%;
    }
</style>
